import env from "../env.js"
import { SnackbarProgrammatic as Snackbar } from 'buefy'
//default tratment of a fetch response
var defaultResponse = (response)=>{
  if (!response.ok) {
    Snackbar.open(response.statusText)
    return {}
  }
  return response.json()
}

var defaultConfirmResponse = (response)=>{
  if (!response.ok) {
    Snackbar.open(response.statusText)
    return {}
  }
  Snackbar.open(response.statusText)
  return response.json()
}
function getDefaultHeaders(method='get',payload){
  let headers = {
    method: method,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }
  if(payload){
    headers.body = JSON.stringify(payload)
  }
  return headers
}

function callApi(url,method="get",payload){
  return new Promise((resolve, reject) => {
      return fetch(url,getDefaultHeaders(method,payload))
      .then((response)=>{
        if(response.ok)
          resolve(defaultResponse(response))
        else
          reject(response)
      },(error)=>{
        reject(error)
      });
    }) 
}


export default {
    user:{
        get:(name)=>{
            return callApi(`${env.apiHost}/user/${name}`)
        },
        getAvailable:(name)=>{
          return callApi(`${env.apiHost}/is_free/${name}`);
      }
    },
    image:{
       get:(name)=>{
            return fetch(`${env.apiHost}/image/${name}`).then((response)=>{
                return response.json()
            });
        },
      post:(name,formData,onError)=>{
        formData.append("jwt",window.localStorage.getItem('mr-jwt'));
        const options = {
          method: 'POST',
          body: formData,
          // If you add this, upload won't work
          // headers: {
          //   'Content-Type': 'multipart/form-data',
          // }
        };
        return fetch(`${env.apiHost}/image/${name}`,options)
              .then(defaultConfirmResponse)
              .catch(onError)
        },
    },
    links:{
        get:(name)=>{
            return callApi(`${env.apiHost}/links/${name}`);
        },
        post:(name,payload)=>{
            payload["jwt"] = window.localStorage.getItem('mr-jwt')
            return callApi(`${env.apiHost}/links/${name}`,'post',payload)
        },
        delete:(id)=>{
            const payload ={"jwt": window.localStorage.getItem('mr-jwt')}
            return callApi(`${env.apiHost}/links/${id}`,'delete',payload)
        },
    },
    style:{
          get:(name)=>{
              return callApi(`${env.apiHost}/style/${name}`);
          },
          post:(name,payload)=>{
              payload["jwt"] = window.localStorage.getItem('mr-jwt')
              return callApi(`${env.apiHost}/style/${name}`,'post',payload)
          },
          delete:(id)=>{
              const payload ={"jwt": window.localStorage.getItem('mr-jwt')}
              return callApi(`${env.apiHost}/style/${id}`,'delete',payload)
          }
    },
    session:{
        login:(payload)=>{
            return callApi(`${env.apiHost}/login`,'post',payload);
        },
        signup:(payload)=>{
            return callApi(`${env.apiHost}/signup`,"post",payload)
        },
    }
}